export const admetParams = {
    "molecular_weight": {
        "parameter": "molecular_weight",
        "stdvalue": "150–500",
        "siunit": "Da",
        "significance": "Indicates drug size suitability for small molecule drugs, influencing absorption and bioavailability."
    },
    "logP": {
        "parameter": "logP",
        "stdvalue": "2–5 ",
        "siunit": "log-ratio",
        "significance": "Represents lipophilicity, affecting membrane permeability and solubility."
    },
    "hydrogen_bond_acceptors": {
        "parameter": "hydrogen_bond_acceptors",
        "stdvalue": "3–5 ",
        "siunit": "count",
        "significance": "Crucial for molecular recognition and target binding."
    },
    "hydrogen_bond_donors": {
        "parameter": "hydrogen_bond_donors",
        "stdvalue": "1–3 ",
        "siunit": "count",
        "significance": "Affects drug solubility and interaction with target proteins."
    },
    "Lipinski": {
        "parameter": "Lipinski",
        "stdvalue": "4",
        "siunit": "count",
        "significance": "Guideline ensuring drug-like properties and ADMET compatibility."
    },
    "QED": {
        "parameter": "QED",
        "stdvalue": "0.6–1.0",
        "siunit": "unitless ",
        "significance": "Quantifies drug-likeness, combining multiple ADMET characteristics."
    },
    "stereo_centers": {
        "parameter": "stereo_centers",
        "stdvalue": "0–3 ",
        "siunit": "count",
        "significance": "Minimizes complexity and increases ease of synthesis and testing."
    },
    "tpsa": {
        "parameter": "tpsa",
        "stdvalue": "20–130",
        "siunit": " Å² ",
        "significance": "Describes polar surface area, influencing solubility and absorption."
    },
    "AMES": {
        "parameter": "AMES",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Indicates non-mutagenicity and safety."
    },
    "BBB_Martins": {
        "parameter": "BBB_Martins",
        "stdvalue": "> 0.3",
        "siunit": "unitless",
        "significance": "Reflects drug's ability to cross the blood-brain barrier."
    },
    "Bioavailability_Ma": {
        "parameter": "Bioavailability_Ma",
        "stdvalue": "> 0.5 ",
        "siunit": "Probability",
        "significance": "Predicts the fraction of the drug absorbed into systemic circulation."
    },
    "CYP1A2_Veith": {
        "parameter": "CYP1A2_Veith",
        "stdvalue": "< 0.2",
        "siunit": "µmol/min/pmol",
        "significance": "Ensures minimal interference with cytochrome P450 enzymes, reducing drug interactions."
    },
    "CYP2C19_Veith": {
        "parameter": "CYP2C19_Veith",
        "stdvalue": "< 0.2",
        "siunit": "µmol/min/pmol",
        "significance": "Ensures minimal interference with cytochrome P450 enzymes, reducing drug interactions."
    },
    "CYP2C9_Substrate_CarbonMangels": {
        "parameter": "CYP2C9_Substrate_CarbonMangels",
        "stdvalue": "< 0.2",
        "siunit": "µmol/min/pmol",
        "significance": "Ensures minimal interference with cytochrome P450 enzymes, reducing drug interactions."
    },
    "CYP2C9_Veith": {
        "parameter": "CYP2C9_Veith",
        "stdvalue": "< 0.2",
        "siunit": "µmol/min/pmol",
        "significance": "Ensures minimal interference with cytochrome P450 enzymes, reducing drug interactions."
    },
    "CYP2D6_Substrate_CarbonMangels": {
        "parameter": "CYP2D6_Substrate_CarbonMangels",
        "stdvalue": "<0.1",
        "siunit": "µmol/min/pmol",
        "significance": "Ensures minimal interference with cytochrome P450 enzymes, reducing drug interactions."
    },
    "CYP2D6_Veith": {
        "parameter": "CYP2D6_Veith",
        "stdvalue": "<0.1",
        "siunit": "µmol/min/pmol",
        "significance": "Ensures minimal interference with cytochrome P450 enzymes, reducing drug interactions."
    },
    "CYP3A4_Substrate_CarbonMangels": {
        "parameter": "CYP3A4_Substrate_CarbonMangels",
        "stdvalue": "<0.1",
        "siunit": "µmol/min/pmol",
        "significance": "Ensures minimal interference with cytochrome P450 enzymes, reducing drug interactions."
    },
    "CYP3A4_Veith": {
        "parameter": "CYP3A4_Veith",
        "stdvalue": "<0.1",
        "siunit": "µmol/min/pmol",
        "significance": "Ensures minimal interference with cytochrome P450 enzymes, reducing drug interactions."
    },
    "Carcinogens_Lagunin": {
        "parameter": "Carcinogens_Lagunin",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Indicates low carcinogenic potential."
    },
    "ClinTox": {
        "parameter": "ClinTox",
        "stdvalue": "0",
        "siunit": "Boolean",
        "significance": "Reflects drug safety and lack of hepatotoxicity."
    },
    "DILI": {
        "parameter": "DILI",
        "stdvalue": "0",
        "siunit": "Boolean",
        "significance": "indicating drug-induced liver injury risk."
    },
    "HIA_Hou": {
        "parameter": "HIA_Hou",
        "stdvalue": "> 0.5 ",
        "siunit": "Probability",
        "significance": "Predicts drug's absorption in the gastrointestinal tract."
    },
    "NR-AR-LBD": {
        "parameter": "NR-AR-LBD",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Represents minimal interaction with nuclear receptors, reducing toxicity."
    },
    "NR-AR": {
        "parameter": "NR-AR",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Represents minimal interaction with nuclear receptors, reducing toxicity."
    },
    "NR-AhR": {
        "parameter": "NR-AhR",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Represents minimal interaction with nuclear receptors, reducing toxicity."
    },
    "NR-Aromatase": {
        "parameter": "NR-Aromatase",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Represents minimal interaction with nuclear receptors, reducing toxicity."
    },
    "NR-ER-LBD": {
        "parameter": "NR-ER-LBD",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Represents minimal interaction with nuclear receptors, reducing toxicity."
    },
    "NR-ER": {
        "parameter": "NR-ER",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Represents minimal interaction with nuclear receptors, reducing toxicity."
    },
    "NR-PPAR-gamma": {
        "parameter": "NR-PPAR-gamma",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Represents minimal interaction with nuclear receptors, reducing toxicity."
    },
    "PAMPA_NCATS": {
        "parameter": "PAMPA_NCATS",
        "stdvalue": "> 0.3 ",
        "siunit": "Probability",
        "significance": "Indicates drug permeability across lipid membranes."
    },
    "Pgp_Broccatelli": {
        "parameter": "Pgp_Broccatelli",
        "stdvalue": "< 0.5 ",
        "siunit": "Probability",
        "significance": "Suggests no significant efflux by P-glycoprotein, ensuring good bioavailability."
    },
    "SR-ARE": {
        "parameter": "SR-ARE",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Involved in antioxidant response to oxidative stress, binding transcription factors like Nrf2."
    },
    "SR-ATAD5": {
        "parameter": "SR-ATAD5",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Plays a role in DNA repair, protein degradation, and mitochondrial function under stress conditions."
    },
    "SR-HSE": {
        "parameter": "SR-HSE",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Induces heat shock proteins to protect cells from stress by refolding misfolded proteins."
    },
    "SR-MMP": {
        "parameter": "SR-MMP",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Enzymes involved in tissue remodeling, inflammation, and wound healing."
    },
    "SR-p53": {
        "parameter": "SR-p53",
        "stdvalue": "<0.5",
        "siunit": "Probability",
        "significance": "Tumor suppressor protein that activates genes involved in cell cycle arrest, apoptosis, and DNA repair."
    },
    "Skin_Reaction": {
        "parameter": "Skin_Reaction",
        "stdvalue": "< 0.5 ",
        "siunit": "Probability",
        "significance": "Indicates inflammatory or repair responses to stress or injury in the skin."
    },
    "hERG": {
        "parameter": "hERG",
        "stdvalue": "< 0.1 ",
        "siunit": "Probability",
        "significance": "Ensures minimal risk of cardiac arrhythmias."
    },
    "Caco2_Wang": {
        "parameter": "Caco2_Wang",
        "stdvalue": "> 1.0",
        "siunit": "Probability",
        "significance": "Indicates potential for good intestinal absorption."
    },
    "Clearance_Hepatocyte_AZ": {
        "parameter": "Clearance_Hepatocyte_AZ",
        "stdvalue": "10 to 20",
        "siunit": "µL/min/mg protein",
        "significance": "Reflects balance between metabolism and therapeutic duration."
    },
    "Clearance_Microsome_AZ": {
        "parameter": "Clearance_Microsome_AZ",
        "stdvalue": "(-10 to -30)",
        "siunit": "log scale",
        "significance": "Reflects balance between metabolism and therapeutic duration."
    },
    "Half_Life_Obach": {
        "parameter": "Half_Life_Obach",
        "stdvalue": "1–12 ",
        "siunit": "hour",
        "significance": "Half_Life_Obach"
    },
    "HydrationFreeEnergy_FreeSolv": {
        "parameter": "HydrationFreeEnergy_FreeSolv",
        "stdvalue": "(-4 to -8)",
        "siunit": "kcal/mol",
        "significance": "Desirable range for solubility, influencing absorption."
    },
    "LD50_Zhu": {
        "parameter": "LD50_Zhu",
        "stdvalue": "> 1000",
        "siunit": "mg/kg",
        "significance": "Suggests low toxicity."
    },
    "Lipophilicity_AstraZeneca": {
        "parameter": "Lipophilicity_AstraZeneca",
        "stdvalue": "0.5–5 ",
        "siunit": "log-ratio",
        "significance": "Refers to the measure of how lipid-soluble a compound is, which is crucial in drug discovery for understanding absorption, distribution, metabolism, and excretion (ADME) properties."
    },
    "PPBR_AZ": {
        "parameter": "PPBR_AZ",
        "stdvalue": "<90%",
        "siunit": "Percentage (%)",
        "significance": "Stands for \"Permeability Prediction by AstraZeneca.\" It involves predicting how well a compound will permeate biological membranes, a key factor in drug absorption and bioavailability."
    },
    "Solubility_AqSolDB": {
        "parameter": "Solubility_AqSolDB",
        "stdvalue": "> 0.5 ",
        "siunit": "log(mol/L)",
        "significance": "Ensures bioavailability through adequate solubility."
    },
    "VDss_Lombardo": {
        "parameter": "VDss_Lombardo",
        "stdvalue": "> 0.2",
        "siunit": "L/kg",
        "significance": "Indicates good distribution to tissues."
    },
    "molecular_weight_drugbank_approved_percentile": {
        "parameter": "molecular_weight_drugbank_approved_percentile",
        "stdvalue": "10–15 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile of molecular weight for approved drugs, indicating distribution among approved compounds."
    },
    "logP_drugbank_approved_percentile": {
        "parameter": "logP_drugbank_approved_percentile",
        "stdvalue": "30–40 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile of partition coefficient (logP) for approved drugs, reflecting lipophilicity."
    },
    "hydrogen_bond_acceptors_drugbank_approved_percentile": {
        "parameter": "hydrogen_bond_acceptors_drugbank_approved_percentile",
        "stdvalue": "10–20 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile of hydrogen bond acceptors for approved drugs, affecting drug-receptor interactions."
    },
    "hydrogen_bond_donors_drugbank_approved_percentile": {
        "parameter": "hydrogen_bond_donors_drugbank_approved_percentile",
        "stdvalue": "20–40 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile of hydrogen bond donors for approved drugs, impacting drug solubility and permeability."
    },
    "Lipinski_drugbank_approved_percentile": {
        "parameter": "Lipinski_drugbank_approved_percentile",
        "stdvalue": "50–75 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile based on Lipinski's rule of five, assessing druglikeness."
    },
    "QED_drugbank_approved_percentile": {
        "parameter": "QED_drugbank_approved_percentile",
        "stdvalue": "60–75 ",
        "siunit": "Percentage (%)",
        "significance": "Quantitative Estimate of Drug-likeness percentile for approved drugs."
    },
    "stereo_centers_drugbank_approved_percentile": {
        "parameter": "stereo_centers_drugbank_approved_percentile",
        "stdvalue": "20–30 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile of stereocenters in approved drugs, important for drug specificity."
    },
    "tpsa_drugbank_approved_percentile": {
        "parameter": "tpsa_drugbank_approved_percentile",
        "stdvalue": "20–30 ",
        "siunit": "Percentage (%)",
        "significance": "Polar surface area (tpsa) percentile for approved drugs, influencing drug permeability."
    },
    "AMES_drugbank_approved_percentile": {
        "parameter": "AMES_drugbank_approved_percentile",
        "stdvalue": "> 70 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile indicating mutagenic potential of approved drugs."
    },
    "BBB_Martins_drugbank_approved_percentile": {
        "parameter": "BBB_Martins_drugbank_approved_percentile",
        "stdvalue": "> 70 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile for blood-brain barrier permeability predictions."
    },
    "Bioavailability_Ma_drugbank_approved_percentile": {
        "parameter": "Bioavailability_Ma_drugbank_approved_percentile",
        "stdvalue": "> 85 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile indicating bioavailability of approved drugs."
    },
    "CYP1A2_Veith_drugbank_approved_percentile": {
        "parameter": "CYP1A2_Veith_drugbank_approved_percentile",
        "stdvalue": "50–60 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile of metabolic activity via CYP1A2 enzyme."
    },
    "CYP2C19_Veith_drugbank_approved_percentile": {
        "parameter": "CYP2C19_Veith_drugbank_approved_percentile",
        "stdvalue": "30–40 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile of metabolic activity via CYP2C19 enzyme."
    },
    "CYP2C9_Substrate_CarbonMangels_drugbank_approved_percentile": {
        "parameter": "CYP2C9_Substrate_CarbonMangels_drugbank_approved_percentile",
        "stdvalue": "20–30 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile indicating metabolism via CYP2C9."
    },
    "CYP2C9_Veith_drugbank_approved_percentile": {
        "parameter": "CYP2C9_Veith_drugbank_approved_percentile",
        "stdvalue": "20–30 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile of metabolic activity via CYP2C9 enzyme."
    },
    "CYP2D6_Substrate_CarbonMangels_drugbank_approved_percentile": {
        "parameter": "CYP2D6_Substrate_CarbonMangels_drugbank_approved_percentile",
        "stdvalue": "20–30 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile indicating metabolism via CYP2D6."
    },
    "CYP2D6_Veith_drugbank_approved_percentile": {
        "parameter": "CYP2D6_Veith_drugbank_approved_percentile",
        "stdvalue": "20–30 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile of metabolic activity via CYP2D6 enzyme."
    },
    "CYP3A4_Substrate_CarbonMangels_drugbank_approved_percentile": {
        "parameter": "CYP3A4_Substrate_CarbonMangels_drugbank_approved_percentile",
        "stdvalue": "50–60 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile indicating metabolism via CYP3A4."
    },
    "CYP3A4_Veith_drugbank_approved_percentile": {
        "parameter": "CYP3A4_Veith_drugbank_approved_percentile",
        "stdvalue": "50–60 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile indicating metabolism via CYP3A4."
    },
    "Carcinogens_Lagunin_drugbank_approved_percentile": {
        "parameter": "Carcinogens_Lagunin_drugbank_approved_percentile",
        "stdvalue": "< 30",
        "siunit": "Percentage (%)",
        "significance": "Percentile indicating carcinogenic risk."
    },
    "ClinTox_drugbank_approved_percentile": {
        "parameter": "ClinTox_drugbank_approved_percentile",
        "stdvalue": "< 30",
        "siunit": "Percentage (%)",
        "significance": "Percentile of clinical toxicity risk."
    },
    "DILI_drugbank_approved_percentile": {
        "parameter": "DILI_drugbank_approved_percentile",
        "stdvalue": "< 10",
        "siunit": "Percentage (%)",
        "significance": "Percentile indicating drug-induced liver injury risk."
    },
    "HIA_Hou_drugbank_approved_percentile": {
        "parameter": "HIA_Hou_drugbank_approved_percentile",
        "stdvalue": "> 80",
        "siunit": "Percentage (%)",
        "significance": "Percentile for human intestinal absorption."
    },
    "NR-AR-LBD_drugbank_approved_percentile": {
        "parameter": "NR-AR-LBD_drugbank_approved_percentile",
        "stdvalue": "< 10 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile for androgen receptor-ligand binding domain."
    },
    "NR-AR_drugbank_approved_percentile": {
        "parameter": "NR-AR_drugbank_approved_percentile",
        "stdvalue": "< 10 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile for androgen receptor binding."
    },
    "NR-AhR_drugbank_approved_percentile": {
        "parameter": "NR-AhR_drugbank_approved_percentile",
        "stdvalue": "< 10 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile for aryl hydrocarbon receptor binding."
    },
    "NR-Aromatase_drugbank_approved_percentile": {
        "parameter": "NR-Aromatase_drugbank_approved_percentile",
        "stdvalue": "< 10",
        "siunit": "Percentage (%)",
        "significance": "Percentile for aromatase enzyme binding."
    },
    "NR-ER-LBD_drugbank_approved_percentile": {
        "parameter": "NR-ER-LBD_drugbank_approved_percentile",
        "stdvalue": "< 10",
        "siunit": "Percentage (%)",
        "significance": "Percentile for estrogen receptor-ligand binding domain."
    },
    "NR-ER_drugbank_approved_percentile": {
        "parameter": "NR-ER_drugbank_approved_percentile",
        "stdvalue": "< 10 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile for estrogen receptor binding."
    },
    "NR-PPAR-gamma_drugbank_approved_percentile": {
        "parameter": "NR-PPAR-gamma_drugbank_approved_percentile",
        "stdvalue": "< 10",
        "siunit": "Percentage (%)",
        "significance": "Percentile for peroxisome proliferator-activated receptor gamma binding."
    },
    "PAMPA_NCATS_drugbank_approved_percentile": {
        "parameter": "PAMPA_NCATS_drugbank_approved_percentile",
        "stdvalue": "> 75",
        "siunit": "Percentage (%)",
        "significance": "Percentile for non-Caco-2 permeability predictions."
    },
    "Pgp_Broccatelli_drugbank_approved_percentile": {
        "parameter": "Pgp_Broccatelli_drugbank_approved_percentile",
        "stdvalue": "< 20",
        "siunit": "Percentage (%)",
        "significance": "Percentile for permeability glycoprotein binding."
    },
    "SR-ARE_drugbank_approved_percentile": {
        "parameter": "SR-ARE_drugbank_approved_percentile",
        "stdvalue": "< 10 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile for antioxidant response element binding."
    },
    "SR-ATAD5_drugbank_approved_percentile": {
        "parameter": "SR-ATAD5_drugbank_approved_percentile",
        "stdvalue": "< 10 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile for ATPase family AAA domain-containing protein binding."
    },
    "SR-HSE_drugbank_approved_percentile": {
        "parameter": "SR-HSE_drugbank_approved_percentile",
        "stdvalue": "< 10 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile for heat shock element binding."
    },
    "SR-MMP_drugbank_approved_percentile": {
        "parameter": "SR-MMP_drugbank_approved_percentile",
        "stdvalue": "< 10",
        "siunit": "Percentage (%)",
        "significance": "Percentile for matrix metalloproteinase activity."
    },
    "SR-p53_drugbank_approved_percentile": {
        "parameter": "SR-p53_drugbank_approved_percentile",
        "stdvalue": "< 10 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile for p53 tumor suppressor binding."
    },
    "Skin_Reaction_drugbank_approved_percentile": {
        "parameter": "Skin_Reaction_drugbank_approved_percentile",
        "stdvalue": "< 20",
        "siunit": "Percentage (%)",
        "significance": "Percentile for skin irritation potential."
    },
    "hERG_drugbank_approved_percentile": {
        "parameter": "hERG_drugbank_approved_percentile",
        "stdvalue": "< 10",
        "siunit": "Percentage (%)",
        "significance": "Percentile for hERG channel binding, indicating cardiac safety."
    },
    "Caco2_Wang_drugbank_approved_percentile": {
        "parameter": "Caco2_Wang_drugbank_approved_percentile",
        "stdvalue": "> 80",
        "siunit": "Percentage (%)",
        "significance": "Percentile for Caco-2 cell permeability predictions."
    },
    "Clearance_Hepatocyte_AZ_drugbank_approved_percentile": {
        "parameter": "Clearance_Hepatocyte_AZ_drugbank_approved_percentile",
        "stdvalue": "20–40",
        "siunit": "Percentage (%)",
        "significance": "Percentile for hepatic clearance predictions by AstraZeneca."
    },
    "Clearance_Microsome_AZ_drugbank_approved_percentile": {
        "parameter": "Clearance_Microsome_AZ_drugbank_approved_percentile",
        "stdvalue": "20–40",
        "siunit": "Percentage (%)",
        "significance": "Percentile for microsomal stability predictions by AstraZeneca."
    },
    "Half_Life_Obach_drugbank_approved_percentile": {
        "parameter": "Half_Life_Obach_drugbank_approved_percentile",
        "stdvalue": "30–60",
        "siunit": "Percentage (%)",
        "significance": "Percentile for plasma half-life predictions by Obach."
    },
    "HydrationFreeEnergy_FreeSolv_drugbank_approved_percentile": {
        "parameter": "HydrationFreeEnergy_FreeSolv_drugbank_approved_percentile",
        "stdvalue": "> 70",
        "siunit": "Percentage (%)",
        "significance": "Percentile for hydration free energy."
    },
    "LD50_Zhu_drugbank_approved_percentile": {
        "parameter": "LD50_Zhu_drugbank_approved_percentile",
        "stdvalue": "> 50 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile for lethal dose 50th percentile prediction."
    },
    "Lipophilicity_AstraZeneca_drugbank_approved_percentile": {
        "parameter": "Lipophilicity_AstraZeneca_drugbank_approved_percentile",
        "stdvalue": "20–50 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile of lipophilicity by AstraZeneca."
    },
    "PPBR_AZ_drugbank_approved_percentile": {
        "parameter": "PPBR_AZ_drugbank_approved_percentile",
        "stdvalue": "10–30 ",
        "siunit": "Percentage (%)",
        "significance": "Percentile for permeability prediction by AstraZeneca."
    },
    "Solubility_AqSolDB_drugbank_approved_percentile": {
        "parameter": "Solubility_AqSolDB_drugbank_approved_percentile",
        "stdvalue": "> 80",
        "siunit": "Percentage (%)",
        "significance": "Percentile for aqueous solubility."
    },
    "VDss_Lombardo_drugbank_approved_percentile": {
        "parameter": "VDss_Lombardo_drugbank_approved_percentile",
        "stdvalue": "> 60",
        "siunit": "Percentage (%)",
        "significance": "Percentile for volume of distribution predictions by Lombardo."
    },
    "PredictedLogS": {
        "parameter": "PredictedLogS",
        "stdvalue": "-12 to 2",
        "siunit": "log-ratio",
        "significance": "LogS is a unit used to measure the solubility of a substance in water. It's the 10-based logarithm of the solubility in mol/L."
    },
    "Predicted LogS (XGBoost)": {
        "parameter": "PredictedLogS",
        "stdvalue": "-12 to 2",
        "siunit": "log-ratio",
        "significance": "LogS is a unit used to measure the solubility of a substance in water. It's the 10-based logarithm of the solubility in mol/L."
    }
    
}